<template>
  <div class="products-input-observer">
    <component
      :is="targetComponent"
      :require-prof="requireProf"
      :csrf-token="csrfToken"
    />
  </div>
</template>

<script>
import ProductsInput03 from './fortunes/ProductsInput03'

export default {
  name: 'ProductsKurenotoriResult',
  components: {
  },
  props: {
    pageId: {
      type: String,
      required: true,
    },
    resultData: {
      type: Object,
      default: null,
    },
    requireProf: {
      type: Array,
      default: null,
    },
    csrfToken: {
      type: String,
      default() {
        return ''
      }
    },
  },
  computed: {
    targetComponent(){
      switch (this.pageId) {
        case '0003':
          return ProductsInput03
      }
    }
  },
  created() {
    console.log('[ products-page: %s ]', this.pageId)
    console.log(' requireProf: %O', this.requireProf)
  },
  mounted() {
  },
  methods: {
  },
}</script>

<style scoped lang='scss'>
@import "../../../../../sass/commons/commonVariables.scss";


</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Products/kurenotori/ProductsKurenotoriInput.vue